import { NavLink } from "react-router-dom";
import { getMe, logout } from "./LogutAction";
import { useState, useRef, useEffect } from "react";
import Languges from "./Languges";
import { useTranslation } from "react-i18next";
import Logo from '../../Images/logo.png'
function Navbar() {
  const { t, i18n } = useTranslation();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const data = await getMe();
        const userData = data?.data || null;
        setUser(userData);
        if (userData) {
          localStorage.setItem("user", JSON.stringify(userData));
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
        setUser(null);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);
  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Lock body scroll when mobile menu is open
  useEffect(() => {
    if (mobileOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [mobileOpen]);

  const isRtl = i18n.language === "ar" || i18n.language === "ckb";

  const getUserInitials = () => {
    if (!user?.name) return "U";
    return user.name.charAt(0).toUpperCase();
  };

  const handleLogout = async () => {
    logout();
  };

  const toggleMobile = () => {
    setMobileOpen((s) => !s);
    if (isDropdownOpen) setIsDropdownOpen(false);
  };

  const navLinks = [
    { to: "/", label: t("home") || "Home", icon: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-4 0a1 1 0 01-1-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 01-1 1" },
    { to: "/customer", label: t("customerPayment") || "Customer Payment", icon: "M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" },
    { to: "/previous-sale", label: t("previousSale") || "Previous Sale", icon: "M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" },
    // { to: "/cancelled-sale", label: t("cancelled") || "Cancelled", icon: "M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" },
  ];

  const desktopLinkClass = ({ isActive }) =>
    `relative flex items-center gap-2 px-4 py-2 rounded-xl text-[13px] font-semibold tracking-wide transition-all duration-300 ${
      isActive
        ? "text-white bg-white/[0.12] shadow-[inset_0_1px_0_0_rgba(255,255,255,0.1)]"
        : "text-white/60 hover:text-white hover:bg-white/[0.06]"
    }`;

  const mobileLinkClass = ({ isActive }) =>
    `flex items-center gap-3 px-4 py-3.5 rounded-2xl text-[15px] font-semibold transition-all duration-300 ${
      isActive
        ? "text-white bg-gradient-to-r from-violet-600 to-indigo-600 shadow-lg shadow-violet-500/25"
        : "text-gray-300 hover:text-white hover:bg-white/[0.06] active:scale-[0.98]"
    }`;

  return (
    <>
      <nav
        dir={isRtl ? "rtl" : "ltr"}
        className="fixed top-0 left-0 right-0 z-50"
      >
        {/* Glass background */}
        <div className="absolute inset-0 bg-[#0f0f23]/80 backdrop-blur-2xl border-b border-white/[0.06]" />

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6">
          <div className="flex items-center justify-between h-16">
            {/* Left: Logo / Brand */}
            <div className="flex items-center gap-3">
              <div className="flex items-center gap-2.5">
                
                 <img src={Logo} alt="Nergz Glass" className="w-10 h-10" />
            
              </div>
            </div>

            {/* Center: Desktop Navigation */}
            <div className="hidden md:flex items-center gap-1 bg-white/[0.04] rounded-2xl p-1.5 border border-white/[0.06]">
              {navLinks.map((link) => (
                <NavLink key={link.to} to={link.to} className={desktopLinkClass}>
                  {link.label}
                </NavLink>
              ))}
            </div>

            {/* Right: Actions */}
            <div className="flex items-center gap-2">
              {/* User code pill */}
              {!loading && user?.code && (
                <div className="hidden lg:flex items-center gap-1.5 bg-emerald-500/10 border border-emerald-500/20 text-emerald-400 px-3 py-1.5 rounded-full">
                  <span className="relative flex h-2 w-2">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
                    <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-400"></span>
                  </span>
                  <span className="text-sm font-mono font-bold">{t("customer_code")}  {user.code}</span>
                </div>
              )}

              {/* Language */}
              <Languges />

              {/* User Avatar + Dropdown */}
              <div className="relative" ref={dropdownRef}>
                {loading ? (
                  <div className="w-9 h-9 rounded-xl bg-white/10 animate-pulse" />
                ) : (
                  <button
                    onClick={() => setIsDropdownOpen((s) => !s)}
                    className={`relative flex items-center gap-2 p-0.5 rounded-xl transition-all duration-300 ${
                      isDropdownOpen
                        ? "ring-2 ring-violet-500/50 bg-white/[0.08]"
                        : "hover:bg-white/[0.06]"
                    }`}
                    aria-expanded={isDropdownOpen}
                    aria-haspopup="true"
                  >
                    <div className="relative w-9 h-9 rounded-xl bg-gradient-to-br from-violet-500 to-indigo-600 flex items-center justify-center overflow-hidden">
                      {user?.image ? (
                        <img
                          src={"https://nergzglass.store/storage/" + user.image}
                          alt={user?.name || "User"}
                          className="w-full h-full object-cover"
                          onError={(e) => {
                            e.target.style.display = "none";
                            if (e.target.nextSibling)
                              e.target.nextSibling.style.display = "flex";
                          }}
                        />
                      ) : null}
                      <div
                        className={`w-full h-full flex items-center justify-center ${
                          user?.image ? "hidden" : "flex"
                        }`}
                      >
                        <span className="text-white font-bold text-sm">
                          {getUserInitials()}
                        </span>
                      </div>
                    </div>
                    {/* Chevron */}
                    <svg
                      className={`w-3.5 h-3.5 text-white/50 transition-transform duration-300 hidden sm:block ${
                        isDropdownOpen ? "rotate-180" : ""
                      }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2.5}
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </button>
                )}

                {/* Dropdown Panel */}
                {isDropdownOpen && !loading && (
                  <div
                    className={`absolute z-50 mt-2 w-72 origin-top-right transition-all duration-300 ${
                      isRtl ? "left-0" : "right-0"
                    }`}
                  >
                    <div className="bg-[#1a1a2e]/95 backdrop-blur-2xl rounded-2xl shadow-2xl shadow-black/40 border border-white/[0.08] overflow-hidden">
                      {/* User Info */}
                      <div className="p-5">
                        <div className="flex items-center gap-3.5">
                          <div className="relative w-12 h-12 rounded-2xl bg-gradient-to-br from-violet-500 to-indigo-600 flex items-center justify-center overflow-hidden shadow-lg shadow-violet-500/20">
                            {user?.image ? (
                              <img
                                src={
                                  "https://nergzglass.store/storage/" +
                                  user.image
                                }
                                alt={user?.name || "User"}
                                className="w-full h-full object-cover"
                                onError={(e) => {
                                  e.target.style.display = "none";
                                  if (e.target.nextSibling)
                                    e.target.nextSibling.style.display = "flex";
                                }}
                              />
                            ) : null}
                            <div
                              className={`w-full h-full flex items-center justify-center ${
                                user?.image ? "hidden" : "flex"
                              }`}
                            >
                              <span className="text-white font-bold text-lg">
                                {getUserInitials()}
                              </span>
                            </div>
                          </div>
                          <div className="flex flex-col min-w-0 flex-1">
                            <span className="text-white font-semibold text-sm truncate">
                              {user?.name || t("user")}
                            </span>
                            <span className="text-white/40 text-xs mt-0.5">
                              {t("user")}
                            </span>
                            {user?.code && (
                              <span className="inline-flex items-center gap-1.5 mt-2 bg-emerald-500/10 text-emerald-400 text-[11px] font-mono font-bold px-2 py-1 rounded-lg w-fit border border-emerald-500/20">
                                <span className="w-1.5 h-1.5 rounded-full bg-emerald-400" />
                                {user.code}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Divider */}
                      <div className="mx-4">
                        <div className="h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />
                      </div>

                      {/* Logout */}
                      <div className="p-2.5">
                        <button
                          onClick={() => {
                            handleLogout();
                            setIsDropdownOpen(false);
                          }}
                          className="w-full flex items-center gap-3 px-3.5 py-3 text-red-400 hover:bg-red-500/10 rounded-xl transition-all duration-200 group active:scale-[0.98]"
                        >
                          <div className="w-9 h-9 rounded-xl bg-red-500/10 flex items-center justify-center group-hover:bg-red-500/20 transition-colors border border-red-500/10">
                            <svg
                              className="w-4.5 h-4.5"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                              />
                            </svg>
                          </div>
                          <div className="flex flex-col items-start">
                            <span className="font-semibold text-sm">
                              {t("logout")}
                            </span>
                            <span className="text-[11px] text-red-400/60">
                              {t("home")}
                            </span>
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Mobile hamburger */}
              <button
                type="button"
                aria-label="Toggle menu"
                aria-expanded={mobileOpen}
                onClick={toggleMobile}
                className="md:hidden relative w-9 h-9 flex items-center justify-center rounded-xl text-white/70 hover:text-white hover:bg-white/[0.06] transition-all duration-300"
              >
                <div className="w-5 h-5 flex flex-col items-center justify-center gap-[5px]">
                  <span
                    className={`block h-[2px] w-5 bg-current rounded-full transition-all duration-300 ${
                      mobileOpen
                        ? "rotate-45 translate-y-[7px]"
                        : ""
                    }`}
                  />
                  <span
                    className={`block h-[2px] w-5 bg-current rounded-full transition-all duration-300 ${
                      mobileOpen ? "opacity-0 scale-0" : ""
                    }`}
                  />
                  <span
                    className={`block h-[2px] w-5 bg-current rounded-full transition-all duration-300 ${
                      mobileOpen
                        ? "-rotate-45 -translate-y-[7px]"
                        : ""
                    }`}
                  />
                </div>
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Spacer for fixed nav */}
      <div className="h-16" />

      {/* Mobile Menu Overlay */}
      <div
        className={`fixed inset-0 z-40 md:hidden transition-all duration-500 ${
          mobileOpen
            ? "visible opacity-100"
            : "invisible opacity-0"
        }`}
      >
        {/* Backdrop */}
        <div
          className={`absolute inset-0 bg-black/60 backdrop-blur-sm transition-opacity duration-500 ${
            mobileOpen ? "opacity-100" : "opacity-0"
          }`}
          onClick={() => setMobileOpen(false)}
        />

        {/* Slide-in Panel */}
        <div
          dir={isRtl ? "rtl" : "ltr"}
          className={`absolute top-0 ${
            isRtl ? "left-0" : "right-0"
          } w-[85%] max-w-sm h-full bg-[#0f0f23]/98 backdrop-blur-2xl border-l border-white/[0.06] transition-transform duration-500 ease-[cubic-bezier(0.32,0.72,0,1)] ${
            mobileOpen
              ? "translate-x-0"
              : isRtl
              ? "-translate-x-full"
              : "translate-x-full"
          }`}
        >
          {/* Mobile header */}
          <div className="flex items-center justify-between p-5 border-b border-white/[0.06]">
            <div className="flex items-center gap-2.5">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-violet-500 to-indigo-600 flex items-center justify-center">
                <svg
                  className="w-4 h-4 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M13 10V3L4 14h7v7l9-11h-7z"
                  />
                </svg>
              </div>
              <span className="text-white font-bold text-base">
                Nergz<span className="text-violet-400">POS</span>
              </span>
            </div>
            <button
              onClick={() => setMobileOpen(false)}
              className="w-8 h-8 rounded-lg bg-white/[0.06] flex items-center justify-center text-white/50 hover:text-white hover:bg-white/[0.1] transition-all"
            >
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2.5}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          {/* Mobile user card */}
          {!loading && user && (
            <div className="mx-4 mt-4 p-4 rounded-2xl bg-gradient-to-br from-violet-600/15 to-indigo-600/10 border border-violet-500/15">
              <div className="flex items-center gap-3">
                <div className="relative w-11 h-11 rounded-xl bg-gradient-to-br from-violet-500 to-indigo-600 flex items-center justify-center overflow-hidden shadow-lg">
                  {user?.image ? (
                    <img
                      src={
                        "https://nergzglass.store/storage/" + user.image
                      }
                      alt={user?.name || "User"}
                      className="w-full h-full object-cover"
                      onError={(e) => {
                        e.target.style.display = "none";
                        if (e.target.nextSibling)
                          e.target.nextSibling.style.display = "flex";
                      }}
                    />
                  ) : null}
                  <div
                    className={`w-full h-full flex items-center justify-center ${
                      user?.image ? "hidden" : "flex"
                    }`}
                  >
                    <span className="text-white font-bold text-sm">
                      {getUserInitials()}
                    </span>
                  </div>
                </div>
                <div className="flex flex-col min-w-0">
                  <span className="text-white font-semibold text-sm truncate">
                    {user?.name || t("user")}
                  </span>
                  {user?.code && (
                    <span className="inline-flex items-center gap-1.5 mt-1 text-emerald-400 text-[11px] font-mono font-bold">
                      <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />
                      {user.code}
                    </span>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* Mobile nav links */}
          <div className="p-4 space-y-1.5 mt-2">
            <p className="text-[11px] font-semibold text-white/30 uppercase tracking-widest px-4 mb-3">
              {t("home")}
            </p>
            {navLinks.map((link, index) => (
              <NavLink
                key={link.to}
                to={link.to}
                onClick={() => setMobileOpen(false)}
                className={mobileLinkClass}
                style={{
                  transitionDelay: mobileOpen
                    ? `${(index + 1) * 75}ms`
                    : "0ms",
                  opacity: mobileOpen ? 1 : 0,
                  transform: mobileOpen
                    ? "translateX(0)"
                    : `translateX(${isRtl ? "-20px" : "20px"})`,
                  transition:
                    "all 0.4s cubic-bezier(0.32, 0.72, 0, 1)",
                }}
              >
                <div className="w-9 h-9 rounded-xl bg-white/[0.06] flex items-center justify-center flex-shrink-0">
                  <svg
                    className="w-[18px] h-[18px]"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={1.8}
                      d={link.icon}
                    />
                  </svg>
                </div>
                {link.label}
              </NavLink>
            ))}
          </div>

          {/* Mobile logout — pinned at bottom */}
          <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-white/[0.06]">
            <button
              onClick={() => {
                handleLogout();
                setMobileOpen(false);
              }}
              className="w-full flex items-center gap-3 px-4 py-3.5 rounded-2xl text-red-400 bg-red-500/[0.06] hover:bg-red-500/[0.12] border border-red-500/10 transition-all duration-300 active:scale-[0.98]"
            >
              <div className="w-9 h-9 rounded-xl bg-red-500/10 flex items-center justify-center">
                <svg
                  className="w-[18px] h-[18px]"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                  />
                </svg>
              </div>
              <span className="font-semibold text-[15px]">
                {t("logout")}
              </span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default Navbar;